<template>
  <component :is="LazyWrapperComponent">
    <slot />
  </component>
</template>

<script lang="ts" setup>
import type { HydrationMode } from '#types/hydration'

import {
  hydrateOnIdle,
  hydrateOnInteraction,
  hydrateOnVisible
} from 'vue'

const { when, interaction = ['touchstart', 'focus', 'click', 'mouseover'], observerOptions } = defineProps<{
  when?: HydrationMode
  interaction?: keyof HTMLElementEventMap | (keyof HTMLElementEventMap)[]
  observerOptions?: IntersectionObserverInit
}>()

const emit = defineEmits<{ hydrated: [] }>()

const slots = defineSlots<{
  default: () => any
}>()

function createHydrationStrategy() {
  switch (when) {
    case 'never':
      return () => () => {}

    case 'idle':
      return hydrateOnIdle()

    case 'visible':
      return hydrateOnVisible(observerOptions)

    case 'interaction':
      return hydrateOnInteraction([interaction].flat())
  }
}

const LazyWrapperComponent = defineAsyncComponent({
  loader: () => Promise.resolve(defineComponent({
    name: 'SlotWrapper',
    setup() {
      onMounted(() => nextTick(() => emit('hydrated')))
      return () => slots.default?.()
    }
  })),
  hydrate: createHydrationStrategy(),
})
</script>
